import { render, staticRenderFns } from "./futureupdata.vue?vue&type=template&id=2666178c&scoped=true&"
import script from "./futureupdata.vue?vue&type=script&lang=js&"
export * from "./futureupdata.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./futureupdata.vue?vue&type=style&index=1&id=2666178c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2666178c",
  null
  
)

export default component.exports